import Worker from 'worker-loader!./web-worker';
import createApp from './main';

const app = createApp(() => new Worker());

app.mount('#app');
